
import BaseService from "./baseService";
import rebateValueApi from "../api/rebateValueApi";
import { getQueryString } from "../utils/common";


class RebateValueService extends BaseService {
  getListByRebateId(query = {}) {
    const newQuery = getQueryString(query)
    return rebateValueApi.getListByRebateId(newQuery).then(response => {
      return {
        data: response.data,
        message: response.message,
        success: response.success
      };
    }, this.handleError);
  }


  addOrUpdateMultipleByRebateId(query, params) {
    const newQuery = getQueryString(query)
    return rebateValueApi.addOrUpdateMultipleByRebateId(newQuery, params).then((response) => {
      return {
        data: response.data,
        message: response.message,
        success: response.success,
      };
    }, this.handleError);
  }

}

export default new RebateValueService();
